import { render, staticRenderFns } from "./acoes-lote.vue?vue&type=template&id=325bd2d6&"
import script from "./acoes-lote.vue?vue&type=script&lang=js&"
export * from "./acoes-lote.vue?vue&type=script&lang=js&"
import style0 from "./acoes-lote.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VScaleTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VMenu,VScaleTransition})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('325bd2d6')) {
      api.createRecord('325bd2d6', component.options)
    } else {
      api.reload('325bd2d6', component.options)
    }
    module.hot.accept("./acoes-lote.vue?vue&type=template&id=325bd2d6&", function () {
      api.rerender('325bd2d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/acoes-lote.vue"
export default component.exports